import { render, staticRenderFns } from "./PaymentRules.vue?vue&type=template&id=63a9a04b"
import script from "./PaymentRules.vue?vue&type=script&lang=js"
export * from "./PaymentRules.vue?vue&type=script&lang=js"
import style0 from "./PaymentRules.vue?vue&type=style&index=0&id=63a9a04b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports